import { EntitiesState } from '@redux/entities'

import type { CampaignModel } from '@models/types'

/*
 * Maps to an object with the shortname as the key
 * { withdrawn: 1, proposal: 2 } etc
 */
export const mapCampaignStatuses = (campaignStatuses: EntitiesState['campaignStatuses']) => {
  const array = Object.values(campaignStatuses).reverse()
  return array.reduce((acc, status) => {
    // @ts-expect-error TS7053
    acc[status.short_name] = status.id
    return acc
  }, {})
}

type MatchFilterCampaignStatusesParams = {
  campaign: CampaignModel,
  campaignStatusId: number,
  campaignStatusShortName?: string,
}

export const matchFilterCampaignStatuses = (params: MatchFilterCampaignStatusesParams) => {
  const { campaign, campaignStatusId, campaignStatusShortName } = params

  const { campaign_status_id, hidden } = campaign

  if (!campaignStatusShortName || campaignStatusShortName === 'all'){
    return true
  }

  if (campaignStatusShortName === 'archived'){
    return hidden
  }

  if (campaignStatusShortName !== 'archived' && hidden){
    return false
  }

  return campaignStatusId === campaign_status_id
}
